import isEmpty from 'lodash-es/isEmpty'
import L from 'leaflet'
import { formatVolume } from '@/shared/number-utils';


function formatPorts(ports) {
  if(isEmpty(ports)) {
    return [];
  }

  let unknownPortCounter = 0;

  return ports.map(port => {
    let portCoords;
    if(!port.coords || isEmpty(port.coords)) {
      // sometimes it's possible to have null in port.coords
      // Null coords should stay at null, and they are then filtered out from the map display.
      portCoords = null;
    } else {
      portCoords = L.latLng(port.coords.lat, port.coords.lon)
    }

    let portName = port.portName;
    if(portName === 'Unknown Port') {
      unknownPortCounter += 1;
      portName = `${portName} ${unknownPortCounter}`;
    }

    return {
      name: portName,
      coords: portCoords,
      volume: port.volume,
      countryCode: port.countryCode,
      popupData: {
        'Country code': port.countryCode,
        'Port name': portName,
        'Volume': formatVolume(port.volume),
      },
    };
  });
}


export {
  formatPorts,
}